import { useLazyQuery, useQuery } from '@apollo/client';

import { aftermarketPartnerApi } from '../api';
import { ProposalsTableDataResponse, ProposalsTableDataVariables } from '../api/types';

export function useFetchDealerDetailsPage(currentAccountId: string, partnerLinkId: string) {
  const { loading: partnerLinkLoading } = useQuery(aftermarketPartnerApi.getPartnerLink, {
    variables: {
      id: partnerLinkId,
    },
    async onCompleted(data) {
      const partnerLink = data?.partnerLink;
      await getDealerAccount({ variables: { dynamicsId: partnerLink.dynamicsPartnerAccountId } });
    },
  });

  const { data: partnerLinkMetricsData, loading: partnerLinkMetricsLoading } = useQuery(
    aftermarketPartnerApi.getPartnerLinkMetrics,
    {
      variables: {
        partnerLinkId,
      },
    }
  );

  const { data: proposalsData, loading: proposalsLoading } = useQuery<
    ProposalsTableDataResponse,
    ProposalsTableDataVariables
  >(aftermarketPartnerApi.getPartnersProposals, {
    variables: { accountId: currentAccountId, partnerLinkId },
  });

  const [getDealerAccount, { data: dealerAccountData, loading: dealerAccountLoading, refetch: refetchDealerAccount }] =
    useLazyQuery(aftermarketPartnerApi.getDealerAccount);

  const isLoading = partnerLinkLoading || partnerLinkMetricsLoading || dealerAccountLoading || proposalsLoading;
  return {
    isLoading,
    partnerLinkMetrics: partnerLinkMetricsData?.partnerLinkMetrics,
    dealerAccount: dealerAccountData?.publicAccount,
    proposals: proposalsData?.partnersProposals,
    refetchDealerAccount,
  };
}
